import { PropsWithChildren } from 'react'

import { combineClassnames } from 'app/common/presentation'

import styles from './Table.module.scss'

interface RowProps extends PropsWithChildren {
  className?: string
  onClick?: () => unknown
}

const Row = ({ children, className, onClick }: RowProps) => (
  <tr
    className={combineClassnames(onClick ? styles.clickable : undefined, className)}
    onClick={onClick}
  >
    {children}
  </tr>
)

export default Row
